// src/GlobalStyle.js
import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

  *, *::before, *::after {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    width: 100%;
    min-height: 100vh;
    overflow-x: hidden;
    font-family: 'Inter', sans-serif;
   background: radial-gradient(circle at top, #fff5ee, #f7f2ff);    
    color: ${({ theme }) => theme.colors.text};
    position: relative;

    /* Frosted glass blur */
  backdrop-filter: none;

    -webkit-backdrop-filter: none;

    /* makes pseudo element visible */
    isolation: isolate;
  }

  /* THE GLOWING BG EFFECT */
  body::before {
    content: "";
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;

    // background: radial-gradient(
    //   circle at 30% 30%,
    //   rgba(255, 100, 180, 0.45), 
    //   transparent 60%
    // ),
    // radial-gradient(
    //   circle at 70% 70%,
    //   rgba(100, 200, 255, 0.35),
    //   transparent 60%
    // ),
    // radial-gradient(
    //   circle at 50% 20%,
    //   rgba(255, 180, 100, 0.25),
    //   transparent 70%
    // );

    filter: blur(80px);
    opacity: 0.9;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  button {
    font-family: inherit;
  }
`;
